import React from 'react';
import styled from 'styled-components';
import { panel } from './panelTheme';
import { PropertiesPanelProperty, PropertiesPanelPropertyContent } from './propertiesPanelProperty';

// UN COMANDO IN MEZZO ALLE PROPRIETÀ, largo quanto la card.
//
// «Reset transform» non è un valore: è una cosa che si fa a tutti e nove i numeri sopra di lui,
// e per questo non sta in una colonna ma attraversa la riga intera. Sotto la terna e non sopra,
// perché si legge dopo aver visto che cosa c'è da azzerare.
//
// NON È IL BOTTONE PRIMARIO DELLA PAGINA — quello è Save, in fascia. Qui è un comando fra i
// parametri, e dipingerlo di arancione metterebbe due primari sullo stesso schermo a contendersi
// lo stesso significato.
const Action = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    min-height: 30px;
    padding: 0 10px;
    border: 1px solid ${panel.line};
    border-radius: 6px;
    background: ${panel.surface};
    color: ${panel.ink};
    font-family: inherit;
    font-size: 12px;
    cursor: pointer;
    transition: background 120ms ease;

    svg {
        width: 14px;
        height: 14px;
    }

    &:hover:not([disabled]) {
        background: ${panel.field};
    }

    &[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export type PropertiesPanelActionPropertyProps = {
    id: string;
    label: React.ReactNode;
    icon?: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
};

export const PropertiesPanelActionProperty: React.FC<PropertiesPanelActionPropertyProps> = ({ id, label, icon, onClick, disabled }) => (
    <PropertiesPanelProperty>
        <PropertiesPanelPropertyContent>
            <Action id={id} type='button' disabled={disabled} onClick={onClick}>
                {icon}
                <span>{label}</span>
            </Action>
        </PropertiesPanelPropertyContent>
    </PropertiesPanelProperty>
);
